module.exports = __webpack_public_path__ + "static/img/M-515-LOVE.13929d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-515-LOVE.png
// module id = gme5
// module chunks = 0